import React from 'react'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <div>
        <footer className='footer' >
  <p className='footer-text'>
    
    
<FontAwesomeIcon
      icon={faCircleQuestion}
      style={{ color: "#ff4d4d", marginRight: "8px" }}
    />

     See something incorrect on this page? Please report by sending an email to 
         {''} <a className='link' href="mailto:PharmacyNetwork@thepharmaforce.com?subject=Inaccuracy in PBM Network Website" >PharmacyNetwork@thepharmaforce.com</a>
  </p>

  <p className='footer-text'>
 <FontAwesomeIcon
      icon={faCircleInfo}
      style={{ color: "black", marginRight: "8px" }}
    />

 For more specific information on Plan and Pharmacy such as claim costs and copays, sign into the {' '}
      <a className='link'  href={`${process.env.REACT_APP_PBM_MEMBER_UI_ENDPOINT}`} target="_blank" rel="noopener noreferrer">
       member portal
      </a> 
      {/* </b> */}
  </p>
</footer>
    </div>
  )
}

export default Footer